import { createContext } from "react";

const SubscriptionsContext = createContext({});

export default SubscriptionsContext;
